'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ja_JP = require('../../date-picker/locale/ja_JP');

var _ja_JP2 = _interopRequireDefault(_ja_JP);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _ja_JP2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/ja_JP.tsx
 ** module id = 765
 ** module chunks = 1
 **/